import { render, staticRenderFns } from "./Badge4.vue?vue&type=template&id=31dbeeb2&scoped=true"
import script from "./Badge4.vue?vue&type=script&lang=js"
export * from "./Badge4.vue?vue&type=script&lang=js"
import style0 from "./Badge4.vue?vue&type=style&index=0&id=31dbeeb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dbeeb2",
  null
  
)

export default component.exports